import React from "react"
import { css } from "emotion"

export const Navbar = () => (
  <div
    className={css`
      background: #e91e63;
      color: #fff;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 30px;
      font-family: monospace;
      text-align: center;
    `}
  >
    Khan Video Linker
  </div>
)
